import React from "react";
import { Provider } from "react-redux";
import { Router, Switch } from "react-router-dom";
import ReactDOM from "react-dom";
import store from "./store";
import "./index.css";
import Routes from "./routes";
import history from "./routes/history";
import { createMuiTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import { SnackbarProvider } from 'notistack';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#2d9f86",
    },
    secondary: {
      main: "#895da7",
    },
  },
});

const snackbarStyle = {
  root:{
    marginTop:'5rem'
  }
}

ReactDOM.render(
  <Provider store={store}>
    <SnackbarProvider maxSnack={5} anchorOrigin={{ vertical: 'top', horizontal:'left' }} classes={snackbarStyle} autoHideDuration={6000}>
      <ThemeProvider theme={theme}>
        <Router history = {history}>
          <Switch>
            <Routes />
          </Switch>
        </Router>
      </ThemeProvider>
    </SnackbarProvider>
  </Provider>,
  document.getElementById("root")
);

